import React from 'react';
const painPoints = ['El domingo a las 23:00 estás juntando apuntes de 5 compañeros distintos que no coinciden entre sí, y mañana tenés parcial.', 'Estudiás horas y horas pero en el examen se te va todo porque nunca tuviste el contenido ordenado de una forma que tenga sentido.', 'Tus resúmenes los armás desde cero cada vez, sin un modelo claro, sin saber si estás yendo por donde el docente espera.', 'Llegás al final sin saber exactamente qué entra, qué es prioritario y cómo conectar los temas entre sí.', 'Estás en segundo o tercer año y todavía sentís que la carrera es un montón de materias sueltas que no tienen ninguna lógica en común.'];
export function PainPoints() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10 text-base leading-6" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, rgb(254,242,242) 12%, rgb(254,242,242) 88%, #FEFAF4 100%)'
  }} data-id="element-184">
      <div className="mx-auto max-w-4xl" data-id="element-185">
        {/* Section Label */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-186">
          ¿Te sentís identificado?
        </p>

        {/* Title */}
        <h2 className="text-center text-2xl sm:text-3xl font-black m-0 mb-2" style={{
        color: '#1E1208'
      }} data-id="element-187">
          Esto le pasa al 90% de los estudiantes de Psicología
        </h2>

        {/* Subtitle */}
        <p className="text-center text-sm m-0 mb-6" style={{
        color: '#9A7B5A'
      }} data-id="element-188">
          No es falta de inteligencia. Es falta de un sistema de estudio real.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-189">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-190">
              <span className="text-red-500 text-base leading-5 shrink-0 font-black" data-id="element-191">
                ✗
              </span>
              <p className="text-xs sm:text-sm m-0" style={{
            color: '#1E1208'
          }} data-id="element-192">
                {point}
              </p>
            </div>)}
        </div>

        {/* Bottom hook */}
        <p className="text-center text-xl sm:text-2xl font-black m-0 mb-6" style={{
        color: '#C8922A'
      }} data-id="element-193">
          ¿Cuántos parciales más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        background: 'linear-gradient(to right, transparent, rgba(200,146,42,0.40), transparent)'
      }} data-id="element-194" />
      </div>

      {/* Degradé inferior → conecta con ProductShowcase */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-195" />
    </section>;
}